export const LOCAL_STORAGE = {
	USER_TOKEN: 'userToken',
	USER_FAVORITES: 'userFavorites',
	USER_MAIN_INFO: 'userMainInfo',
	CART: 'cart',
	USER_EMAIL: 'userEmail',
};
